var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MPCloseIcon',{staticClass:"close-icon",attrs:{"size":18,"aria-label":"Close"},on:{"click":_vm.onDismiss}}),(!_vm.isLoading)?_c('RegisterCheckout',{on:{"onCheckout":_vm.onCheckout}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }